<template>
    <div
        class="sidebars"
        :class="{
            [`theme-${layout.theme}`]: true,
            'open': layout.sidebars?.left || layout.sidebars?.right
        }"
    >
        <div class="background" @click="close" />
        <div
            class="sidebar left"
            :class="{
                'open': layout.sidebars?.left,
            }"
        >
            <slot name="sidebar-left" />
        </div>
        <div
            class="sidebar right"
            :class="{
                'open': layout.sidebars?.right,
            }"
        >
            <slot name="sidebar-right" />
        </div>
    </div>
</template>
<script setup>
import { ref, inject, watch } from '#imports';
import { useScrollLock } from '@vueuse/core';

const scrollLock = import.meta.server ? ref(false) : useScrollLock(window.document.querySelector('body'));

const layout = inject('layout');

watch(() => layout.value.sidebars.right, to => {
    scrollLock.value = to;
});

watch(() => layout.value.sidebars.left, to => {
    scrollLock.value = to;
});

function close() {
    layout.value.sidebars = {
        left: false,
        right: false,
    };
}
</script>
<style scoped>
.sidebars {
  position: fixed;
  z-index: 6;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  pointer-events: none;
}
.sidebars .background {
  transition: opacity 0.5s ease;
  opacity: 0;
}
.sidebars > * {
  grid-row-start: 1;
}
.sidebars.theme-white .sidebar, .sidebars.theme-clear .sidebar {
  background: var(--color-base-white);
}
.sidebars.open {
  pointer-events: auto;
}
.sidebars.open .background {
  opacity: 1;
}
.sidebars .background {
  grid-column-start: 1;
  grid-column-end: span 3;
  justify-self: stretch;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(0.125rem);
}
.sidebars .sidebar {
  position: relative;
  z-index: 2;
  grid-column-end: span 2;
  transition: transform 0.5s cubic-bezier(0.19, 0.73, 0.23, 1);
  max-height: 100%;
  overflow-y: scroll;
}
.sidebars .sidebar.left {
  grid-column-start: 1;
  transform: translateX(-102%);
}
.sidebars .sidebar.right {
  grid-column-start: 2;
  transform: translateX(102%);
}
.sidebars .sidebar.open {
  transition: transform 0.5s cubic-bezier(0.19, 0.73, 0.23, 1);
  transform: translateX(0);
  opacity: 1;
}
</style>
